/**
 * Lazily loaded MUI date pickers. Each one brings its own dayjs LocalizationProvider, so callers
 * need no provider of their own and the picker code (~420 KB emitted) only loads on first use.
 */
import React, { lazy, Suspense } from 'react'
import type { Dayjs } from 'dayjs'
import type { DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import type { DateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker'

const DatePickerImpl = lazy(() => import('./pickersImpl').then((m) => ({ default: m.DatePickerWithProvider })))
const DateTimePickerImpl = lazy(() => import('./pickersImpl').then((m) => ({ default: m.DateTimePickerWithProvider })))

export const LazyDatePicker = (props: DatePickerProps<Dayjs>) => (
    <Suspense fallback={null}>
        <DatePickerImpl {...props} />
    </Suspense>
)

export const LazyDateTimePicker = (props: DateTimePickerProps<Dayjs>) => (
    <Suspense fallback={null}>
        <DateTimePickerImpl {...props} />
    </Suspense>
)
